/* @flow */

import _ from 'lodash';

export const getAllCaligrafixBookProgressByChild = (state: Object, child_id) => (_.get(state.caligrafix_book_progress, [child_id], []));

export const getCaligrafixBookProgressById = (state, caligrafix_book_id) => (_.find(state.caligrafix_book_progress, { caligrafix_book_id: caligrafix_book_id }) || {});

export const getCaligrafixBookHistory = (state, child_id, caligrafix_book_id) => (_.get(state.caligrafix_book_history, [child_id, caligrafix_book_id], null));
